<template>

    <div class="admin-panel">
        <customModalSidebar :settings="customSidebarSettings"></customModalSidebar>
        <div class="info-status" v-if="loadingAction">
            <b-spinner label="Spinning"></b-spinner>
        </div>
        <customModalDialog :settings="customModalSettings"></customModalDialog>
    </div>

</template>

<script>
    // import plugins
    import Vue from 'vue';
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import scrollTo from 'vue-scrollto';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';
    import translate from "@/helpers/translate"
    // import components
    import errorMixin from '@/mixins/errorMixin';
    import scrollToMixin from '@/mixins/scrollToMixin';
    import customModalDialog from '@/components/widgets/customModalDialog';
    import customModalSidebar from '@/components/widgets/customModalSidebar';
    //  tabs
    import closeAccountRequests from '@/components/admin/tabs/closeAccountRequests';
    import landingQuestions from '@/components/admin/tabs/landingQuestions';
    import shortLinks from '@/components/admin/tabs/shortLinks';
    import landingFiles from '@/components/admin/tabs/landingFiles';
    import pdfGeneration from '@/components/admin/tabs/pdfGeneration';
    import Organization from "./tabs/Organization";
    import Places from "./tabs/Places";
    import UnlinkedQuestions from "./tabs/UnlinkedQuestions";
    import Votes from "./tabs/Votes";
    import Profiles from "./tabs/Profiles";
    import SecondLevelDetails from "./tabs/SecondLevelDetails";
    import Subscriptions from "@/components/admin/tabs/subscriptions";
    import serviceRequests from "@/components/admin/tabs/serviceRequests";
    import userActions from "@/components/admin/tabs/userActions";
    import locationIssues from "@/components/admin/tabs/locationIssues";

    Vue.use(scrollTo)

    export default {
        name: 'list',
        components: {
            Subscriptions,
            SecondLevelDetails,
            Profiles,
            Votes,
            UnlinkedQuestions,
            Places,
            Organization,
            customModalDialog,
            customModalSidebar,
            vSelect,
            closeAccountRequests,
            landingQuestions,
            shortLinks,
            landingFiles,
            pdfGeneration,
            serviceRequests,
            userActions,
            locationIssues,
        },
        mixins: [mixin, errorMixin, scrollToMixin],
        data() {
            return {
                activeTab: +localStorage.getItem('activeTabAdminPanel') || 0,
                loadingAction: false,
                loadingUpdate: false,
                customModalSettings: {},
                modalConfirmMessage: '',
                page: 1,
                infiniteId: +new Date(),
                customSidebarSettings: {},
                secondLevelConfigSettings: null,
                unlinkedQuestions: {
                    sticker_types: ['default', 'default_with_hints', 'stahla']
                },
                renderClass: 'desktop'
            }
        },
        computed: {
            ...mapState({
                defaultRoles: state => state.auth.defaultRoles,
                stateStatus: state => state.question.stateStatus
            }),

            ...mapGetters({
                isUserOwner: 'auth/isUserOwner',
                isUserAdmin: 'auth/isUserAdmin',
                isUserSiteManager: 'auth/isUserSiteManager',
                isUserOrgManager: 'auth/isUserOrgManager'
            }),

        },

        watch: {
            activeTab(value) {
                localStorage.setItem('activeTabAdminPanel', value)
            },
        },

        mounted() {
            if (localStorage.getItem('access_token') == undefined) {
                this.$router.push('/sign-in');
                return false;
            }
            this.renderClass = window.innerWidth > 1000 ? 'desktop' : 'mobile'

            let lastAdminRoute = localStorage.getItem('last_admin_route_name')
            if(lastAdminRoute) {
                this.$router.push({name: lastAdminRoute})
            } else {
                this.$router.push({name: 'votes'})
            }
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.scrollOptions.container = '#places_list'
                if (vm.scrolledItem && from.name === 'QRquestions') {
                    vm.$scrollTo(vm.scrolledItem, -1, vm.scrollOptions)
                    vm.saveScrolledItem(null)
                }
            })
        },

        methods: {
            ...mapActions({
                updateProfileLang: 'profiles/updateProfileLang',
            }),

            ...mapMutations({
                saveScrolledItem: 'saveScrolledItem',
            }),
            async onCreatePdfClick(guids) {
                this.showPdfConfigDialog = true
                console.log(guids)
                this.pdfConfigDialogModel.guids = guids
            },
        }
    }
</script>

<style scoped>

    .printed-mark {
        min-width: 20px;
        margin: 0 25px;
        font-size: 22px;
        color: #6c757d;
        display: inline-block;
    }

    .list-group-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        transition: all 0.15s ease;
        display: -ms-flexbox;
        display: -webkit-flex;
    }

    @media screen and (max-width: 1000px) {
        .list-group-item {
            min-height: 4.5em;
        }
    }

    .list-group-item:hover {
        background: #6c757d5c
    }

    .info-status {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%);
        width: 90vw;
    }

    .list-group-item .place_rate {
        width: 3.5em;
        transform: scale(1.9);
    }

    .list-group-item img {
        transform: scale(1.5);
        margin-right: 30px;
        width: 20px;
        height: 20px;
    }






    @media screen and (max-width: 1000px) {

        .list-group-item img {
            width: 45px;
            height: 45px;
        }
    }

    .list-group-item span {
        color: #000;
    }





    @media screen and (max-width: 1000px) {
        .face-container-add ul {
            min-width: 90vw;
        }
    }

    /* ##### ##### ##### ##### Stickers ##### ##### ##### ##### */

</style>
<style>

    .admin-panel {
        height: calc(100vh - 64px);
    }

    .list-group {
        margin-bottom: 5em;
    }
</style>
